import React from 'react';
import { connect } from 'react-redux';
import PageBase from '../../../widgets/PageBase/PageBase';
import { injectIntl } from 'react-intl';
import { format, addMonths, addDays } from 'date-fns';
import CircularProgress from 'material-ui/CircularProgress';
import DateFnsUtils from '@date-io/date-fns';
import { RaisedButton } from 'material-ui';
import { Snackbar } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { PureComponent } from 'react';
import * as api from '../../../../services/api';
import {
  DEFAULT_ACTIVE_BRANCH_ID,
  ISO_DATE_FORMAT
} from '../../../../constants/constants';
import { Parser } from '@json2csv/plainjs';
import { showCSV, showZip } from '../../../../utils/file-util';
import { cloneDeep } from 'lodash';
import MarketCenterReportTable from './MarketCenterReportTable';
import { completedRenewalsReportFields, mcReportFields , noDeviationReportFields} from './ReportsFields';
import AwaitingReportTable from './AwaitingReportTable';
import {
  getBranchIds
} from '../../../../utils/api-util';
import * as RenewalStatus from '../../../../constants/RenewalStatus';

const mapStateToProps = (state) => ({ appStore: state.get('app').toJS() });

const classificationMapping = {
  WITHIN_MAD: 'renewal_within_MAD',
  BELOW_MAD_OR_QUANTITY_DECREASED: 'renewed_below_MAD_or_qty_decreased', 
  NO_DEVIATION:'renewal_with_no_deviation'
};

const toDateString = (dateStr) => String(dateStr).substring(0, 10);

class CompletedRenewalsReportsPage extends PureComponent {
  constructor(props) {
    super(props);

    this.updateState = this.updateState.bind(this);
    this.getBranchIds = this.getBranchIds.bind(this);
    this.getCompletedRenewalsReport =
      this.getCompletedRenewalsReport.bind(this);
    this.getCompletedNoDeviationRenewalsReport =
      this.getCompletedNoDeviationRenewalsReport.bind(this);
    this.generateCSV = this.generateCSV.bind(this);
    this.getMarketCenterReport = this.getMarketCenterReport.bind(this);
    this.getMarketCenterReportCSV = this.getMarketCenterReportCSV.bind(this);
    this.getAwaitingReportData = this.getAwaitingReportData.bind(this);
    this.translatedFields = this.translatedFields.bind(this);
    this.getAllCompletedRenewalReports = this.getAllCompletedRenewalReports.bind(this);
    this.state = {
      completedStartDate: addMonths(new Date(), -1),
      completedEndDate: new Date(),
      mcStartDate: addDays(new Date(), -6), // 7 days including current day
      mcEndDate: new Date(),
      message: null,
      generatingDownload: false,
      generatingMCReport: true,
      MCReportData: [], 
      awaitingReportData: [], 
      generatingAwaitingReport: true
    };

    this.intl = this.props.intl;
  }

  componentDidMount() {
    this.getMarketCenterReport();
    this.getAwaitingReportData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mcEndDate !== this.state.mcEndDate ||
      prevState.mcStartDate !== this.state.mcStartDate ||
      this.props.appStore.activeBranchId !== prevProps.appStore.activeBranchId
    ) {
      this.setState(
        {
          MCReportData: [],
          generatingMCReport: true
        },
        () => this.getMarketCenterReport()
      );
    }
  }

  updateState(updatedState) {
    this.setState(updatedState);
  }

  getBranchIds() {
    return DEFAULT_ACTIVE_BRANCH_ID !== this.props.appStore.activeBranchId
      ? this.props.appStore.branches
          .filter(
            (branch) => branch.branchId === this.props.appStore.activeBranchId
          )
          .map((branch) => branch.branchId)
      : this.props.appStore.branches.map((branch) => branch.branchId);
  }

  normaliseReportData(completedRenewals) {
    return completedRenewals.map((data) => ({
      ...data,
      absDate: toDateString(data.absDate),
      classification: this.props.intl.formatMessage({
        id: classificationMapping[data.classification]
      })
    }));
  }

  normaliseNoDeviationReportData(noDeviationRenewals) {
    return noDeviationRenewals.map((data) => ({
      ...data,
      absDate: toDateString(data.absDate),
      previousCXD: (data.previousContractExpirationDate === null) ? '' : toDateString(data.previousContractExpirationDate),
      newCXD: (data.newContractExpirationDate === null) ? '' : toDateString(data.newContractExpirationDate),
      classification: this.props.intl.formatMessage({
        id: classificationMapping[data.classification]
      })
    }));
  }

  translatedFields(fields) {
    const duplicatedFields = cloneDeep(fields);
    duplicatedFields.forEach(
      (field) =>
        (field.label = this.props.intl.formatMessage({
          id: field.label
        }))
    );
    return duplicatedFields;
  }

  updateStateWithMessage(idMessage){
    this.updateState({
      message: this.props.intl.formatMessage({
        id: idMessage
      }),
      generatingDownload: false
    });
  }

  getAllCompletedRenewalReports(){
    const { completedStartDate, completedEndDate } = this.state;
    const ALL_MARKET_CENTER = "ALL";
    this.updateState({ generatingDownload: true });
    const marketCenterName = this.props.appStore.activeBranchId === DEFAULT_ACTIVE_BRANCH_ID ? ALL_MARKET_CENTER
                              : this.props.appStore.branches.filter((branch) => branch.branchId === this.props.appStore.activeBranchId)[0].branchName;
    const formattedStartDate = format(new Date(completedStartDate), ISO_DATE_FORMAT);
    const formattedEndDate = format(new Date(completedEndDate), ISO_DATE_FORMAT);

    api.archivedRenewals
    .getZipCompletedReport(
      this.getBranchIds(), formattedStartDate, formattedEndDate
    )
    .then((response) => {
      try {
        if (!!response.data && response.data.byteLength > 0) {
          showZip(response.data, `${marketCenterName}_${formattedStartDate}_${formattedEndDate}`);
          this.updateStateWithMessage('completed_renewal_contracts_success_message');
        } else {
          this.updateStateWithMessage('no_completed_renewal_contracts_in_this_time_period_message');
        }
      } catch (error) {
        this.updateStateWithMessage('completed_renewals_report_error_message');
      }
    })
    .catch((error) =>{
      this.updateStateWithMessage('completed_renewals_report_error_message');
    });
  }

  getCompletedRenewalsReport() {
    const { completedStartDate, completedEndDate } = this.state;
    this.updateState({ generatingDownload: true });
    api.archivedRenewals
      .getReport(
        this.getBranchIds(),
        format(new Date(completedStartDate), ISO_DATE_FORMAT),
        format(new Date(completedEndDate), ISO_DATE_FORMAT)
      )
      .then((response) => {
        try {
          if (!!response.data && response.data.length > 0) {
            this.generateCSV(
              this.normaliseReportData(response.data),
              this.translatedFields(completedRenewalsReportFields),
              "'CompletedRenewals_'MM_dd_yyyy_HH_mm_ss"
            );
            this.updateStateWithMessage('completed_renewals_report_success_message');
          } else {
            this.updateStateWithMessage('no_completed_renewals_in_this_time_period_message');
          }
        } catch (error) {
          this.updateStateWithMessage('completed_renewals_report_failed_to_generate_csv_message');
        }
      })
      .catch((error) => {
        this.updateStateWithMessage('completed_renewals_report_error_message');
      });
  }

  getCompletedNoDeviationRenewalsReport() {
    const { completedStartDate, completedEndDate } = this.state;
    this.updateState({ generatingDownload: true });
    api.archivedRenewals
      .getNoDeviationReport(
        this.getBranchIds(),
        format(new Date(completedStartDate), ISO_DATE_FORMAT),
        format(new Date(completedEndDate), ISO_DATE_FORMAT)
      )
      .then((response) => {
        try {
          if (!!response.data && response.data.length > 0) {
            this.generateCSV(
              this.normaliseNoDeviationReportData(response.data),
              this.translatedFields(noDeviationReportFields),
              "'NoDeviationRenewals_'MM_dd_yyyy_HH_mm_ss"
            );
            this.updateStateWithMessage('no_deviation_renewals_report_success_message');
          } else {
            this.updateStateWithMessage('no_deviation_renewals_not_available_in_this_time_period_message');
          }
        } catch (error) {
          this.updateStateWithMessage('no_deviation_renewals_report_failed_to_generate_csv_message');
        }
      })
      .catch((error) => {
        this.updateStateWithMessage('completed_renewals_report_error_message');
      });
  }


  generateCSV(data, fields, name) {
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(data);
    showCSV(csv, format(new Date(), name));
  }

  getMarketCenterReport() {
    api.archivedRenewals
      .getMarketCenterReport(this.getBranchIds())
      .then((response) => {
        try {
          if (!!response.data && response.data.length > 0) {
            this.updateState({
              MCReportData: response.data,
              generatingMCReport: false
            });
          } else {
            this.updateState({
              generatingMCReport: false
            });
          }
        } catch (error) {
          this.updateStateWithMessage('market_center_report_failed_respond');
        }
      })
      .catch((error) =>
        this.updateStateWithMessage('market_center_report_failed_respond')
      );
  }

  getMarketCenterReportCSV(reportData) {
    this.generateCSV(
      reportData,
      this.translatedFields(mcReportFields),
      "'MCReport_'MM_dd_yyyy_HH_mm_ss"
    );
  }

  async getAwaitingReportData(){
    try {
      const { activeBranchId, branches } = this.props.appStore;
      const branchIds = getBranchIds(activeBranchId, branches);
      const promises = branchIds.map(async branchId => {
        const branch = branches.filter((b) => b.branchId === branchId)[0];
        const branchIdArr = [branchId];
        const response = await api.customers.count({
          statuses: [RenewalStatus.APPROVAL_REQUIRED.name],
          branchIds: branchIdArr,
          mustHaveContract: true
        })  
        const responseData = !!response.data ? response.data : 0;
        
        return {requiringApprovalCount: responseData, branch: branch};
      });

      const result = await Promise.all(promises)
      const filteredResult = result.filter((record) => record.requiringApprovalCount > 0);
      this.updateState({
         awaitingReportData: filteredResult, 
         generatingAwaitingReport: false
        });
    }  catch (error) {
      this.updateStateWithMessage('awaiting_approval_report_error_message')
    }
  }

  render() {
    const { MCReportData, awaitingReportData } = this.state;
    return (
      <PageBase
        navigation={[
          this.props.intl.formatMessage({
            id: 'reports_portal'
          })
        ]}
      >
        <h3>
          {this.props.intl.formatMessage({
            id: 'completed_renewals_report'
          })}
        </h3>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              format="dd MMMM yyyy"
              label={this.props.intl.formatMessage({ id: 'start_date' })}
              disableFuture
              maxDate={this.state.completedEndDate}
              value={this.state.completedStartDate}
              onChange={(data) =>
                this.updateState({ completedStartDate: data })
              }
              style={{ marginBottom: '20px' }}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              format="dd MMMM yyyy"
              label={this.props.intl.formatMessage({ id: 'end_date' })}
              disableFuture
              minDate={this.state.completedStartDate}
              value={this.state.completedEndDate}
              onChange={(data) => this.updateState({ completedEndDate: data })}
              style={{ marginBottom: '20px' }}
            />
          </MuiPickersUtilsProvider>
        </div>
        {
          !this.state.generatingDownload ?
          <div>
            <RaisedButton
              label={this.props.intl.formatMessage({
                id: 'export_completed_report'
              })}
              primary
              onClick={this.getCompletedRenewalsReport}
            />

            <RaisedButton
              label={this.props.intl.formatMessage({
                id: 'export_completed_renewal_contracts'
              })}
              primary
              onClick={this.getAllCompletedRenewalReports}
              style={{ margin: '10px' }}
            />

            <RaisedButton
              label={this.props.intl.formatMessage({
                id: 'export_no_deviation_renewal_reports'
              })}
              primary
              onClick={this.getCompletedNoDeviationRenewalsReport}
              style={{ margin: '10px' }}
            />
          </div>
          : 
          (
            <div style={{ width: '100%', display: 'flex', margin: '10px' }}>
              <CircularProgress style={{ margin: 'auto' }} />
            </div>
          )
        }
        
        <div>
        <h3>
          {this.props.intl.formatMessage({
            id: 'awaiting_approvals_report'
          })}
        </h3>
          { !this.state.generatingAwaitingReport
            ? <AwaitingReportTable 
                  awaitingReportData = {awaitingReportData}
                />
            : (
              <div style={{ width: '100%', display: 'flex', margin: '10px' }}>
                <CircularProgress style={{ margin: 'auto' }} />
              </div>
            )
          }
        </div>
        <div>
          <h3>
            {this.props.intl.formatMessage({ id: 'market_center_report' })}
          </h3>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              format="dd MMMM yyyy"
              label={this.props.intl.formatMessage({ id: 'start_date' })}
              disableFuture
              maxDate={this.state.mcEndDate}
              value={this.state.mcStartDate}
              onChange={(data) => this.updateState({ mcStartDate: data })}
              style={{ marginBottom: '20px' }}
              disabled={this.state.generatingMCReport}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              format="dd MMMM yyyy"
              label={this.props.intl.formatMessage({ id: 'end_date' })}
              disableFuture
              minDate={this.state.mcStartDate}
              value={this.state.mcEndDate}
              onChange={(data) => this.updateState({ mcEndDate: data })}
              style={{ marginBottom: '20px' }}
              disabled={this.state.generatingMCReport}
            />
          </MuiPickersUtilsProvider>
        </div>
     
        {!this.state.generatingMCReport ? (
          !!MCReportData && Object.entries(MCReportData).length > 0 ? (
            <MarketCenterReportTable
              startDate={format(
                new Date(this.state.mcStartDate),
                ISO_DATE_FORMAT
              )}
              endDate={format(new Date(this.state.mcEndDate), ISO_DATE_FORMAT)}
              reportData={MCReportData}
              exportToCSV={this.getMarketCenterReportCSV}
            />
          ) : (
            <div>
              {this.props.intl.formatMessage({
                id: 'no_market_center_report_found'
              })}
            </div>
          )
        ) : (
          <div style={{ width: '100%', display: 'flex', margin: '10px' }}>
            <CircularProgress style={{ margin: 'auto' }} />
          </div>
        )}
        <Snackbar
          open={!!this.state.message}
          onClose={() => {
            this.setState({ message: null });
          }}
          autoHideDuration={5000}
          message={this.state.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </PageBase>
    );
  }
}

export default connect(mapStateToProps)(
  injectIntl(CompletedRenewalsReportsPage)
);
